import React, { useContext } from 'react';

import Divider from '../../../../common/elements/Divider/Divider';
import useAppInfo from '../../../../common/hooks/useAppInfo';
import { ACCESS_TO_LOGS_INVESTIGATOR_OPERATIONS } from '../../../../constants/userOperations';
import { userHasAccessTo } from '../../../../services/auth';
import { PageInfoHeader } from '../../../PageInfoHeader/PageInfoHeader';
import { ADVERSE_EVENTS_WIDGET, DEVIATION_WIDGET } from '../shared/Worklist/constants';
import WorklistChips from '../shared/Worklist/WorklistChips';
import { WorklistFilters } from '../shared/Worklist/WorklistFilters';
import { WorklistStatusMessageAndSearchField } from '../shared/Worklist/WorklistStatusMessageAndSearchField';
import { WorklistWidget } from '../shared/Worklist/WorklistWidget';

import {
  colors,
  investigatorAdverseEventsAndDeviationStatusesProvider,
  investigatorStatusesProvider
} from './constants';
import { InvestigatorWorklistContext, withInvestigatorContext } from './InvestigatorWorklistFilterContext';
import { InvestigatorWorklistTableNew } from './InvestigatorWorklistTableNew';

import '../shared/Worklist/WorklistStyles.scss';

const InvestigatorWorklistNew = () => {
  const Context = useContext(InvestigatorWorklistContext);
  const {
    features: { deviationReviewCycleEnabled }
  } = useAppInfo();
  return (
    <div className={'worklist-new'}>
      <div className="worklist-header">
        <PageInfoHeader>
          <WorklistFilters Context={Context} />
          <WorklistChips Context={Context} />
        </PageInfoHeader>
        <div className={'worklist-widget-container'}>
          <WorklistWidget
            Context={Context.EncounterWidgetContext}
            colors={colors}
            statusProvider={investigatorStatusesProvider}
          />
          {userHasAccessTo(ACCESS_TO_LOGS_INVESTIGATOR_OPERATIONS) && (
            <>
              <WorklistWidget
                Context={Context.AdverseEventsWidgetContext}
                colors={colors}
                statusProvider={investigatorAdverseEventsAndDeviationStatusesProvider}
                widgetType={ADVERSE_EVENTS_WIDGET}
              />
              {deviationReviewCycleEnabled && (
                <WorklistWidget
                  Context={Context.DeviationWidgetContext}
                  colors={colors}
                  statusProvider={investigatorAdverseEventsAndDeviationStatusesProvider}
                  widgetType={DEVIATION_WIDGET}
                />
              )}
            </>
          )}
        </div>
      </div>
      <Divider className={'worklist-divider'} />
      <WorklistStatusMessageAndSearchField Context={Context} statusesProvider={investigatorStatusesProvider} />
      <InvestigatorWorklistTableNew />
    </div>
  );
};

export default withInvestigatorContext(InvestigatorWorklistNew);
